import $ from 'jquery';

function orders() {
  $('.container')
    .on('click', '.add_field', function (e) {
      e.preventDefault();
      const field_html = $(this).attr('data-new-field');
      $('#orderline_fields').append(
        field_html.replace(/new_orderlines/g, new Date().getTime().toString())
      );
    })
    .on('click', '.remove_field', function (e) {
      e.preventDefault();
      $(this).prev('input[type=hidden]').val('1');
      $(this).prev('input[type=hidden]').prependTo('#orderline_fields');
      $(this).closest('tr').remove();
    });
}

document.addEventListener('turbolinks:load', orders);
document.addEventListener('ajax:success', orders);
